module.exports = __webpack_public_path__ + "media/images/map/map3-58404c1f91d94f830878a877b8bc3876.png";